import { useEffect } from "react";
import { useLocation } from "react-router-dom";
const DEFAULT_DESCRIPTION =
  "DIR Nation connects communities, preserves heritage and builds a shared global future.";
const TITLES = {
  "/": "DIR Nation — One People, Shared Future",
  "/about": "About DIR Nation",
  "/heritage": "Heritage & Genealogy",
  "/global-network": "Global Network",
  "/news": "News",
  "/articles": "Articles",
  "/blogs": "Blogs",
  "/events": "Events",
  "/opportunities": "Opportunities",
  "/organizations": "Organizations",
  "/initiatives": "Initiatives",
  "/media": "Media",
  "/contact": "Contact",
  "/privacy": "Privacy Policy",
  "/terms": "Terms of Use",
  "/cookies": "Cookie Policy",
};
function setMeta(selector, key, value) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(key, selector.match(/=\"(.+)\"/)?.[1]);
    document.head.appendChild(element);
  }
  element.setAttribute("content", value);
}
export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const base = TITLES[pathname] || "DIR Nation";
    const title = base.includes("DIR Nation") ? base : `${base} | DIR Nation`;
    const canonical = `${window.location.origin}${pathname}`;
    document.title = title;
    setMeta('meta[name="description"]', "name", DEFAULT_DESCRIPTION);
    setMeta('meta[property="og:title"]', "property", title);
    setMeta('meta[property="og:description"]', "property", DEFAULT_DESCRIPTION);
    setMeta('meta[property="og:url"]', "property", canonical);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonical;
  }, [pathname]);
  return null;
}
